function recentEmailFetchAddresses(emailFilter) {
  const search = String(emailFilter || '').trim();
  if (!search) return [];
  return search
    .split(/[|,]/)
    .map((term) => term.trim())
    .filter((term) => term.includes('@'));
}

module.exports = {
  recentEmailFetchAddresses,
};
